import * as React from "react";
import Svg, { Path, Rect } from "react-native-svg";

function Cube() {
  return (
    <Svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <Path
        d="M15.8625 4.40418L9.675 1.01723C9.46822 0.903426 9.23603 0.84375 9 0.84375C8.76397 0.84375 8.53178 0.903426 8.325 1.01723L2.1375 4.40418C1.9161 4.52533 1.73138 4.70382 1.60272 4.92093C1.47405 5.13805 1.40619 5.38579 1.40625 5.63817V12.3614C1.40619 12.6138 1.47405 12.8616 1.60272 13.0787C1.73138 13.2958 1.9161 13.4743 2.1375 13.5954L8.325 16.9824C8.53174 17.0963 8.76395 17.1561 9 17.1561C9.23605 17.1561 9.46826 17.0963 9.675 16.9824L15.8625 13.5954C16.0839 13.4743 16.2686 13.2958 16.3973 13.0787C16.5259 12.8616 16.5938 12.6138 16.5938 12.3614V5.63817C16.5938 5.38579 16.5259 5.13805 16.3973 4.92093C16.2686 4.70382 16.0839 4.52533 15.8625 4.40418ZM9 2.57114L14.0625 5.34356L9 8.11387L3.9375 5.34356L9 2.57114ZM3.09375 6.80536L8.15625 9.57567V14.9665L3.09375 12.1948V6.80536ZM9.84375 14.9665V9.57567L14.9062 6.80536V12.1948L9.84375 14.9665Z"
        fill="#667085"
      />
    </Svg>
  );
}

export default Cube;
